/*
 * Copyright (c) 2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {useAppDispatch, useAppSelector} from "../../../../redux/hooks";
import {selectVehicleProgramsDevelopmentStagesTree, selectVehicleProgramsMainData, setDevelopmentStagesTree} from "../../../../redux/ducks/VehicleProgramsDetails/slice";
import {useHasWriteAccess} from "../../../../redux/ducks/AccessControl/accessControlHelpers";
import {usePostRequest} from "../../../../api/helper";
import {VEHICLE_PROGRAMS_CONSTANTS} from "../constants";
import * as React from "react";
import {toast} from "react-hot-toast";
import ArgosFlexbox from "../../../components/Containers/ArgosFlexbox";
import {LEFT_PANEL_ITEMS_PADDING} from "../../../components/Tree/Parts/JamaTreeContainer";
import ArgosButton from "../../../components/Buttons/ArgosButton";
import SeparatorLine from "../../../components/Separator/SeparatorLine";
import {theme} from "../../../../constants/theme";
import {IconButton, Tooltip} from "@mui/material";
import NoteAddOutlined from "@mui/icons-material/AutoFixHighOutlined";
import VehicleProgramsTree from "./VehicleProgramsTree/VehicleProgramsTree";
import {useEffect} from "react";

const WizardIcon = (props: any) => {
  return (
    <div>
      <Tooltip title="Import Sensor Position Spreadsheet" arrow>
        <IconButton
          onClick={() => {
            props.onClick()
          }}
        >
          <NoteAddOutlined style={{color: '#3481d5'}}/>
        </IconButton>
      </Tooltip>
    </div>
  )
}

const LeftPanel = (props: any) => {
  const {setWizardDialogOpen, loadingMainData} = props
  const dispatch = useAppDispatch()
  const developmentStagesTree = useAppSelector(selectVehicleProgramsDevelopmentStagesTree)
  const vehicleProgramId = useAppSelector(state => selectVehicleProgramsMainData(state)?.vehicleProgramId)
  const isProgramArchive = useAppSelector(state => selectVehicleProgramsMainData(state)?.isProgramArchive)

  // fetch dev stage id to data
  const fetchDevStageIdToDataHandle = usePostRequest(VEHICLE_PROGRAMS_CONSTANTS.itemDetails.endpoints.devStageIdToData)
  useEffect(() => {

  }, []);

  /**
   * Access control
   */
  const writeAccess = useHasWriteAccess()
  const hasWriteAccess = !isProgramArchive && writeAccess
  const fetchTreeHandle = usePostRequest(VEHICLE_PROGRAMS_CONSTANTS.itemDetails.endpoints.getVehicleProgramTree)
  const [refreshingTree, setRefreshingTree] = React.useState(false)
  const fetchTree = () => {
    if (!vehicleProgramId) return
    setRefreshingTree(true)
    fetchTreeHandle({vehicleProgramId})
      .then((res: any) => {
        dispatch(setDevelopmentStagesTree(res))
      })
      .catch((err: any) => {
        toast.error('Error fetching tree')
        console.log('error', err)
      })
      .finally(() => {
        setRefreshingTree(false)
      })
  }

  const nodeDataLoading = loadingMainData || refreshingTree
  return (
    <div style={{display: 'flex', flexFlow: 'column', width: "100%", height: "100%", background: '#ffffff', overflow: 'auto'}}>
      <ArgosFlexbox vertical rowGap={5}>
        <ArgosFlexbox
          style={{justifyContent: 'left', marginTop: 5, marginLeft: 5, padding: LEFT_PANEL_ITEMS_PADDING}}>

          <div>
            {hasWriteAccess && <WizardIcon onClick={() => {
              dispatch(setWizardDialogOpen(true))
            }}/>}
          </div>
          <ArgosButton
            onClick={() => {
              fetchTree()
            }}
          >
            REFRESH TREE
          </ArgosButton>
        </ArgosFlexbox>
        <SeparatorLine style={{background: theme.layout.header.backgroundColor}}/>
      </ArgosFlexbox>
      <div
        style={{
          overflow: 'auto',
          flex: 1,
          padding: LEFT_PANEL_ITEMS_PADDING,
          scrollbarGutter: 'stable',
        }}
      >
        <VehicleProgramsTree developmentStagesTree={developmentStagesTree} nodeDataLoading={nodeDataLoading}/>
      </div>
    </div>
  )
}

export default LeftPanel